<template>
  <div class="kg-page">
    <div id="kg-container" class="kg-container"></div>
    <KgMenu />
    <KgRightbar />
    <KgNodeDialog />
    <KgEdgeDialog />
    <KgClusterDialog />
    <KgClusterNodeDialog />
    <KgPathDialog />
    <KgPathNodeDialog />
    <KgResourceListBar />
  </div>
</template>

<script>
import {
  initGraph,
  formatNodes,
  formatEdges,
  formatCluster,
  formatPathEdges,
  pluginContextmenu,
  pluginTooltip,
  defaultBehaviors,
} from './knowledgeGraph/hypergraph'
import {
  list,
  relationList,
  hyperedgeList,
  del,
  relationDel,
  hyperedgeDel,
  hyperedgeUnbindKnowledge,
  studyPathList,
  studyPathKnowledgeList,
  studyPathDel,
  studyPathKnowledgeDel,
} from '@/request/api/knowledge_graph.js'
import { chapter_tree } from '@/request/api/course.js'

import KgMenu from './knowledgeGraph/components/KgMenu.vue'
import KgRightbar from './knowledgeGraph/components/KgRightbar.vue'
import KgNodeDialog from './knowledgeGraph/components/KgNodeDialog.vue'
import KgEdgeDialog from './knowledgeGraph/components/KgEdgeDialog.vue'
import KgClusterDialog from './knowledgeGraph/components/KgClusterDialog.vue'
import KgClusterNodeDialog from './knowledgeGraph/components/KgClusterNodeDialog.vue'
import KgPathDialog from './knowledgeGraph/components/KgPathDialog.vue'
import KgPathNodeDialog from './knowledgeGraph/components/KgPathNodeDialog.vue'
import KgResourceListBar from './knowledgeGraph/components/KgResourceListBar.vue'
import { knowledgeResourceList } from '@/request/api/knowledge_graph.js'

export default {
  name: 'KnowledgeGraphPage',
  components: {
    KgMenu,
    KgRightbar,
    KgNodeDialog,
    KgEdgeDialog,
    KgClusterDialog,
    KgClusterNodeDialog,
    KgPathDialog,
    KgPathNodeDialog,
    KgResourceListBar,
  },
  provide() {
    return {
      courseId: this.courseIdRef,
      btnActiveBus: this.btnActiveBus,
      menuActiveBus: this.menuActiveBus,
      chapterListData: this.chapterListData,
      hypergraphPathData: this.hypergraphPathData,
      relationTypeList: this.relationTypeList,
      clusterTypeList: this.clusterTypeList,
      getknowledgeData: this.getknowledgeData,
      getHypergraphstudypathData: this.getHypergraphstudypathData,
      getHypergraphstudypathNodeData: this.getHypergraphstudypathNodeData,
      nodeDialog: this.nodeDialog,
      edgeDialog: this.edgeDialog,
      clusterDialog: this.clusterDialog,
      clusterNodeDialog: this.clusterNodeDialog,
      pathDialog: this.pathDialog,
      pathNodeDialog: this.pathNodeDialog,
      graphNodes: this.graphNodes,
      graphEdges: this.graphEdges,
      graphClusters: this.graphClusters,
      graphAction: this.graphAction,
      graphModule: this.graphModule,
      resourceListBarOpt: this.resourceListBarOpt,
    }
  },
  data() {
    return {
      requestVersion: 0,
      courseIdRef: { value: '' },
      courseName: '',
      btnActiveBus: { value: null },
      menuActiveBus: [],
      chapterListData: [],
      graphNodes: [],
      graphEdges: [],
      graphClusters: [],
      hypergraphPathData: [],
      relationTypeList: [
        { text: '后置' },
        { text: '关联' },
      ],
      clusterTypeList: [
        { text: '普通超边' },
        { text: '资源超边' },
        { text: '任务超边' },
      ],
      nodeDialog: {
        visible: false,
        type: 'add',
        form: { chapterId: '', name: '', difficultyLevel: 0 },
      },
      edgeDialog: {
        visible: false,
        type: 'add',
        form: { relationType: 0, sourceKnowledgeId: '', targetKnowledgeId: '' },
      },
      clusterDialog: {
        visible: false,
        type: 'add',
        form: { quoteId: '', name: '', hyperedgeType: 0 },
      },
      clusterNodeDialog: {
        visible: false,
        type: 'add',
        form: { name: '', hyperedgeId: '', knowledgeId: '' },
      },
      pathDialog: {
        visible: false,
        type: 'add',
        form: { name: '' },
      },
      pathNodeDialog: {
        visible: false,
        type: 'add',
        form: { orderIndex: 0, knowledgeId: '', studyPathId: '', path_name: '', path_id: '' },
      },
      graphModule: { value: null },
      resourceListBarOpt: { visible: false, data: [] },
    }
  },
  mounted() {
    this.courseIdRef.value = this.$route.query.courseId || ''
    this.courseName = this.$route.query.courseName || ''
    this.initGraphFun()
    this.getknowledgeData()
    this.getCourseChapterListFun()
    this.getHypergraphstudypathData()
  },
  beforeDestroy() {
    if (this.graphModule.value) {
      this.graphModule.value.destroy()
    }
  },
  methods: {
    // 初始化空图谱（与目标项目一致：先创建空图，再用 setData 填充数据）
    initGraphFun() {
      this.graphModule.value = initGraph()
    },
    // 根据章节选中情况收集需要查询的 chapterId 列表
    getChapterIds() {
      if (!this.menuActiveBus || !this.menuActiveBus.length) return []
      // 如果选中了小节（第二级），直接返回小节 ID
      if (this.menuActiveBus.length >= 2) {
        return [this.menuActiveBus[1].id]
      }
      // 选中了章（第一级），收集该章下所有小节 ID
      var chapterId = this.menuActiveBus[0].id
      var chapter = null
      for (var i = 0; i < this.chapterListData.length; i++) {
        if (this.chapterListData[i].id == chapterId) {
          chapter = this.chapterListData[i]
          break
        }
      }
      if (!chapter) return [chapterId]
      var children = chapter.children || chapter.chapters || []
      if (!children.length) return [chapterId]
      // 章 ID + 所有小节 ID
      var ids = [chapterId]
      children.forEach(function (child) { ids.push(child.id) })
      return ids
    },
    // 获取章节知识点、关系、超边
    async getknowledgeData() {
      var self = this
      // 切回章节视图时隐藏资源列表
      this.resourceListBarOpt.visible = false
      this.resourceListBarOpt.data = []
      // 版本号防止竞态条件
      this.requestVersion++
      var currentVersion = this.requestVersion
      var courseId = this.courseIdRef.value
      var chapterIds = this.getChapterIds()
      try {
        var nodesData = []
        var edgesData = []
        if (chapterIds.length <= 1) {
          // 小节被选中或未选章节：单次请求
          var params = { courseId: courseId }
          if (chapterIds.length === 1) params.chapterId = chapterIds[0]
          var results = await Promise.all([list(params), relationList(params)])
          if (self.requestVersion !== currentVersion) return
          nodesData = (results[0].code == 0 ? results[0].data : null) || []
          edgesData = (results[1].code == 0 ? results[1].data : null) || []
        } else {
          // 章被选中：并行请求章及所有小节的数据并去重合并
          var promises = []
          chapterIds.forEach(function (cid) {
            var p = { courseId: courseId, chapterId: cid }
            promises.push(list(p))
            promises.push(relationList(p))
          })
          var results2 = await Promise.all(promises)
          if (self.requestVersion !== currentVersion) return
          var nodeIdMap = {}
          var edgeIdMap = {}
          for (var i = 0; i < results2.length; i += 2) {
            var nodes = (results2[i].code == 0 ? results2[i].data : null) || []
            var edges = (results2[i + 1].code == 0 ? results2[i + 1].data : null) || []
            nodes.forEach(function (n) {
              if (!nodeIdMap[n.id]) { nodeIdMap[n.id] = true; nodesData.push(n) }
            })
            edges.forEach(function (e) {
              if (!edgeIdMap[e.id]) { edgeIdMap[e.id] = true; edgesData.push(e) }
            })
          }
        }

        console.log('[KG] raw nodes:', nodesData.length, 'raw edges:', edgesData.length)

        // 过滤无效边：只保留 source 和 target 都在当前节点集中的边
        var nodeIdSet = {}
        nodesData.forEach(function (n) { nodeIdSet[n.id] = true })
        edgesData = edgesData.filter(function (e) {
          var srcId = (e.sourceKnowledge && e.sourceKnowledge.id) || e.sourceKnowledgeId
          var tgtId = (e.targetKnowledge && e.targetKnowledge.id) || e.targetKnowledgeId
          return nodeIdSet[srcId] && nodeIdSet[tgtId]
        })

        console.log('[KG] filtered edges:', edgesData.length)

        // 使用 splice 保持数组引用不变，确保 provide/inject 响应性
        self.graphNodes.splice(0, self.graphNodes.length, ...nodesData)
        self.graphEdges.splice(0, self.graphEdges.length, ...edgesData)

        // 用 setData 设置实际数据（与目标项目一致）
        self.graphModule.value.setData({
          nodes: formatNodes(nodesData),
          edges: formatEdges(edgesData),
        })

        // 重置交互状态
        self.graphModule.value.setBehaviors(defaultBehaviors)

        // 设置插件（先清空超边）
        self.graphModule.value.setPlugins(function (currentPlugins) {
          return [
            pluginTooltip(),
            pluginContextmenu('chapter', self.graphModule.value, self.graphAction, true),
          ]
        })
        await self.graphModule.value.render()

        // 加载超边
        var clustersData = []
        if (chapterIds.length <= 1) {
          var clusterParams = { courseId: courseId }
          if (chapterIds.length === 1) clusterParams.chapterId = chapterIds[0]
          var clustersRes = await hyperedgeList(clusterParams)
          if (self.requestVersion !== currentVersion) return
          clustersData = (clustersRes.code == 0 ? clustersRes.data : null) || []
        } else {
          var clusterPromises = []
          chapterIds.forEach(function (cid) {
            clusterPromises.push(hyperedgeList({ courseId: courseId, chapterId: cid }))
          })
          var clusterResults = await Promise.all(clusterPromises)
          if (self.requestVersion !== currentVersion) return
          var clusterIdMap = {}
          clusterResults.forEach(function (res) {
            var data = (res.code == 0 ? res.data : null) || []
            data.forEach(function (c) {
              if (!clusterIdMap[c.id]) { clusterIdMap[c.id] = true; clustersData.push(c) }
            })
          })
        }
        // 给超边下的知识点加上 hyperedgeId
        clustersData.forEach(function (item) {
          if (item.knowledgeList && item.knowledgeList.length) {
            item.knowledgeList.forEach(function (k) {
              k.hyperedgeId = item.id
            })
          }
        })
        self.graphClusters.splice(0, self.graphClusters.length, ...clustersData)

        if (clustersData.length) {
          self.graphModule.value.setPlugins(function (currentPlugins) {
            return [
              pluginTooltip(),
              pluginContextmenu('chapter', self.graphModule.value, self.graphAction, true),
            ].concat(formatCluster(clustersData))
          })
          await self.graphModule.value.render()
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },

    // 获取章节列表
    getCourseChapterListFun() {
      var self = this
      chapter_tree({ courseId: this.courseIdRef.value }).then(function (res) {
        if (res.data && res.data.length) {
          self.chapterListData.splice(0, self.chapterListData.length, ...res.data)
        }
      })
    },

    // 获取学习路径
    getHypergraphstudypathData() {
      var self = this
      studyPathList({ courseId: this.courseIdRef.value }).then(function (res) {
        var data = (res.code == 0 ? res.data : null) || []
        self.hypergraphPathData.splice(0, self.hypergraphPathData.length, ...data)
      })
    },

    // 获取学习路径下的知识点
    async getHypergraphstudypathNodeData() {
      var self = this
      if (!this.btnActiveBus.value) return
      var res = await studyPathKnowledgeList({ studyPathId: this.btnActiveBus.value })
      var listData = (res.code == 0 ? res.data : null) || []

      self.graphModule.value.setData({
        nodes: formatNodes(listData),
        edges: formatEdges(formatPathEdges(listData)),
      })

      // 设置节点点击行为：点击知识点显示关联资源列表
      var nodeClickBehavior = {
        type: 'click-select',
        degree: 0,
        state: 'selected',
        onClick: function (event) {
          var targetType = event.target && event.target.type
          var targetId = event.target && event.target.id
          if (targetType === 'node') {
            var nodeData = self.graphModule.value.getNodeData(targetId)
            var knowledgeId = (nodeData && nodeData.data && (nodeData.data.knowledgeId || nodeData.data.id)) || targetId
            if (!knowledgeId) {
              self.resourceListBarOpt.visible = false
              self.resourceListBarOpt.data = []
              return
            }
            // 通过知识点ID查询关联资源（课程知识点的keyPoint字段存储的是知识点ID）
            knowledgeResourceList({ keyPoint: String(knowledgeId), page: 1, size: 100 }).then(function (res) {
              var list = []
              if (res.code === 0 && res.data) {
                var rawList = res.data.list || res.data.records || []
                if (!Array.isArray(rawList)) rawList = []
                // 精确过滤：只保留课程知识点类型且keyPoint精确匹配当前知识点ID的记录
                var kid = String(knowledgeId)
                list = rawList.filter(function (kp) {
                  return kp.keyPointType === 2 && String(kp.keyPoint) === kid
                })
              }
              console.log('[KG] 知识点资源列表:', knowledgeId, list.length, list)
              self.resourceListBarOpt.data = list
              self.resourceListBarOpt.visible = true
            }).catch(function (err) {
              console.error('获取资源列表失败:', err)
              self.resourceListBarOpt.visible = false
            })
          } else {
            self.resourceListBarOpt.visible = false
            self.resourceListBarOpt.data = []
          }
        },
      }

      self.graphModule.value.setBehaviors([
        'zoom-canvas',
        'drag-element',
        'drag-canvas',
        nodeClickBehavior,
      ])

      self.graphModule.value.setPlugins(function () {
        return [
          pluginTooltip('path'),
          pluginContextmenu('path', self.graphModule.value, self.graphAction, true),
        ]
      })
      self.graphModule.value.render()
    },

    // 统一操作分发
    graphAction(type, data) {
      data = data || {}
      var id = data.id || null
      var name = data.name
      switch (type) {
        case 'addNode':
          this.nodeDialog.visible = true
          this.nodeDialog.type = 'add'
          this.nodeDialog.form = { chapterId: '', name: '', difficultyLevel: 0 }
          break
        case 'editNode':
          this.nodeDialog.visible = true
          this.nodeDialog.type = 'edit'
          this.nodeDialog.form = {
            id: id,
            chapterId: data.chapterId,
            name: name,
            difficultyLevel: data.difficultyLevel,
          }
          break
        case 'delNode':
          this.handleRemove('node', id)
          break
        case 'addEdge':
          this.edgeDialog.visible = true
          this.edgeDialog.type = 'add'
          this.edgeDialog.form = {
            relationType: 0,
            sourceKnowledgeId: id || '',
            targetKnowledgeId: '',
          }
          break
        case 'editEdge':
          this.edgeDialog.visible = true
          this.edgeDialog.type = 'edit'
          this.edgeDialog.form = {
            id: id,
            relationType: data.relationType,
            sourceKnowledgeId: data.sourceKnowledgeId,
            targetKnowledgeId: data.targetKnowledgeId,
          }
          break
        case 'delEdge':
          this.handleRemove('edge', id)
          break
        case 'addCluster':
          this.clusterDialog.visible = true
          this.clusterDialog.type = 'add'
          this.clusterDialog.form = { quoteId: '', name: '', hyperedgeType: 0 }
          break
        case 'editCluster':
          this.clusterDialog.visible = true
          this.clusterDialog.type = 'edit'
          this.clusterDialog.form = {
            id: id,
            quoteId: data.quoteId,
            name: name,
            hyperedgeType: data.hyperedgeType,
          }
          break
        case 'delCluster':
          this.handleRemove('cluster', id)
          break
        case 'addClusterNode':
          this.clusterNodeDialog.visible = true
          this.clusterNodeDialog.type = 'add'
          this.clusterNodeDialog.form = {
            name: name,
            hyperedgeId: id,
            knowledgeId: '',
          }
          break
        case 'delClusterNode':
          this.handleRemove('clusterNode', {
            hyperedgeId: data.hyperedgeId,
            knowledgeId: id,
          })
          break
        case 'addPath':
          this.pathDialog.visible = true
          this.pathDialog.type = 'add'
          this.pathDialog.form = { name: '' }
          break
        case 'editPath':
          this.pathDialog.visible = true
          this.pathDialog.type = 'edit'
          this.pathDialog.form = { id: id, name: name }
          break
        case 'delPath':
          this.handleRemove('path', id)
          break
        case 'addPathNode':
          this.pathNodeDialog.visible = true
          this.pathNodeDialog.type = 'add'
          this.pathNodeDialog.form = {
            orderIndex: 0,
            knowledgeId: '',
            studyPathId: '',
            path_name: name,
            path_id: id,
          }
          break
        case 'editPathNode':
          var editPathId = data.studyPathId || this.btnActiveBus.value
          var editPathName = ''
          for (var pi = 0; pi < this.hypergraphPathData.length; pi++) {
            if (this.hypergraphPathData[pi].id == editPathId) {
              editPathName = this.hypergraphPathData[pi].name
              break
            }
          }
          this.pathNodeDialog.visible = true
          this.pathNodeDialog.type = 'edit'
          this.pathNodeDialog.form = {
            orderIndex: data.orderIndex || 0,
            knowledgeId: data.knowledgeId || id,
            path_name: editPathName || name,
            path_id: editPathId,
            id: id,
          }
          break
        case 'delPathNode':
          this.handleRemove('pathNode', data.id || id)
          break
      }
    },

    // 删除交互
    handleRemove(type, data) {
      var self = this
      var name = '知识点删除'
      var reqFn = null
      switch (type) {
        case 'node':
          name = '知识点删除'
          reqFn = function () { return del(data) }
          break
        case 'edge':
          name = '关系删除'
          reqFn = function () { return relationDel(data) }
          break
        case 'cluster':
          name = '超边删除'
          reqFn = function () { return hyperedgeDel(data) }
          break
        case 'clusterNode':
          name = '超边中的知识点移除'
          reqFn = function () { return hyperedgeUnbindKnowledge(data.hyperedgeId, [data.knowledgeId]) }
          break
        case 'path':
          name = '学习路径删除'
          reqFn = function () { return studyPathDel(data) }
          break
        case 'pathNode':
          name = '学习路径中的知识点移除'
          reqFn = function () { return studyPathKnowledgeDel(data) }
          break
      }
      this.$confirm('确定将选择' + name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(function () {
        return reqFn()
      }).then(function () {
        switch (type) {
          case 'path':
            self.getHypergraphstudypathData()
            break
          case 'pathNode':
            self.getHypergraphstudypathNodeData()
            break
          default:
            self.getknowledgeData()
            break
        }
        self.$message.success('操作成功')
      }).catch(function () {})
    },
  },
}
</script>

<style scoped lang="less">
.kg-page {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 10px;
  box-sizing: border-box;
  background: #f0f2f5;
}
.kg-container {
  width: 100%;
  height: 100%;
}
</style>
